// Libs
import { useState, useEffect } from 'react'
import styled, { css } from 'styled-components'

// Comps
import { H5 as H5Base } from '../Headings'
import { genericCheckBox } from '../../utils/styles'
import { colors, fontWeights, mobileScreen } from '../../utils'

const H5 = styled(H5Base)`
  color: ${colors.black};
`
const Container = styled.div`
  width: 100%;

  display: flex;
  margin-left: auto;
  margin-right: auto;

  .checkboxInput {
    ${genericCheckBox}
  }

  .checkboxInfo {
    margin-left: 20px;
  }

  .checkboxText {
    color: ${colors.black};
    margin: 0;
    margin-top: 10px;
    font-weight: ${fontWeights.normal};
    font-size: 14px;
    line-height: 1.3;
    letter-spacing: -0.6px;
    width: 100%;

    ${mobileScreen(css`
      margin-top: 0;
    `)}
  }
`

// Props.
interface Props {
  initialValue?: boolean // If you are using this as create field
  value?: boolean // If you are using this as an edit field
  // Do not use initialValue and value at the same time
  onChange?: (value: boolean) => void
  title?: React.ReactNode
  description?: React.ReactNode
  className?: string
}

// A checkbox that fits into the same styling as the FormField
export const FormFieldCheckbox: React.FC<Props> = (props) => {
  // Props
  const { initialValue, value, onChange, title, description, className } = props

  // Local State
  const [internalValue, setInternalValue] = useState(initialValue || false)

  // on value changed by parent
  useEffect(() => {
    // make sure if not set we don't set the value to null/not boolean
    if (value == true || value == false) {
      setInternalValue(value)
    }
  }, [value])

  // ..
  return (
    <Container className={`FormFieldCheckbox ${className || ''}`}>
      <input
        className="checkboxInput"
        onChange={() => {
          setInternalValue(!internalValue)
          if (onChange) {
            onChange(!internalValue)
          } else {
            console.log('@FormFieldCheckbox->onChange no function set')
          }
        }}
        type="checkbox"
        checked={internalValue}
      />
      <div className="checkboxInfo">
        <H5>{title || ''}</H5>
        <p className="checkboxText">{description || ''}</p>
      </div>
    </Container>
  )
}
